import { useEffect } from 'react';
import type { UseFormSetFocus, FieldValues, FieldPath } from 'react-hook-form';

/**
 * Automatically sets focus to a specific React Hook Form field when the component mounts.
 * @param setFocus - The setFocus function from useForm().
 * @param name - The name of the field to focus.
 * @param delay - Time in ms to wait before focusing (default 50ms).
 */
export function useAutoFocus<TFieldValues extends FieldValues>(
    setFocus: UseFormSetFocus<TFieldValues>,
    name: FieldPath<TFieldValues>,
    delay = 50
) {
    useEffect(() => {
        const timer = setTimeout(() => {
            setFocus(name);
        }, delay);

        return () => clearTimeout(timer);
    }, [setFocus, name, delay]);
}
